// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_80mm_85mm_1_label_layout__3W2SH"};